<template>
  <div>
    <button v-for="(action,index) in actions" :class="buttonClass" @click="$emit('actionClick',action)">
      {{actionAlias[action[actionLabelPath]]||action[actionLabelPath]}}
    </button>
  </div>
</template>

<script>
  export default {
    name: "buttons-control",
    props:{
      actions:{
        type:Array,
        default:()=>[]
      },
      actionAlias:{
        type:Object,
        default:()=>{return {}}
      },
      actionLabelPath:{
        type:String,
        default:"title"
      },
      buttonClass:{
        type:String,
        default:"ui basic button"
      }
    }
  }
</script>

<style scoped>

</style>
